import { render, staticRenderFns } from "./DiscussionForumForm.vue?vue&type=template&id=586901d9&"
import script from "./DiscussionForumForm.vue?vue&type=script&lang=js&"
export * from "./DiscussionForumForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports